module.exports = __webpack_public_path__ + "img/login_bg.8c144f16.png";